module.exports = __webpack_public_path__ + "static/customize_advanced_1-a3920928475ab22f1e79048d8fe542d2.png";